import React, { useState, useEffect, useRef } from 'react';
import PocketBase from 'pocketbase';
import './Header.css'; 
import customCallIcon from './call.png'; 

const pb = new PocketBase('https://bahcarplaza.com');
const CITIES = ['Kolkata', 'Mumbai', 'Delhi', 'Bangalore', 'Chennai', 'Pune', 'Hyderabad', 'Ahmedabad', 'Jaipur'];

// 🚨 UPDATED: Added "My Address" to Header Menu 🚨
const MENU_ITEMS = [
  { name: 'My Bookings', icon: '🗓️' },
  { name: 'My Orders', icon: '📦' },
  { name: 'My Ad', icon: '🚗' },
  { name: 'Post Ad', icon: '🏷️' }, 
  { name: 'Wishlist', icon: '❤️' },
  { name: 'Analytics', icon: '📊' },
  { name: 'Wallet', icon: '💰' },
  { name: 'My Address', icon: '📍' }, // 👈 NEW ITEM
  { name: 'Profile Update', icon: '⚙️' }
];

function Header({ view, setView, setSearchTerm, setCityFilter, activeTab, setActiveTab }) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isAccountDropdownOpen, setIsAccountDropdownOpen] = useState(false);
  
  const dropdownRef = useRef(null);
  const mobileMenuRef = useRef(null); 

  useEffect(() => {
    const handlePopState = (e) => {
      if (!e.state || !e.state.headerMenuOpen) {
        setIsMobileMenuOpen(false);
        setIsAccountDropdownOpen(false);
      }
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  const closeMenus = () => {
    if (window.history.state && window.history.state.headerMenuOpen) {
      window.history.back(); 
    }
    setIsMobileMenuOpen(false);
    setIsAccountDropdownOpen(false);
  };

  const toggleMobileMenu = () => {
    if (isMobileMenuOpen) {
      closeMenus();
    } else {
      setIsMobileMenuOpen(true);
      setIsAccountDropdownOpen(false);
      window.history.pushState({ headerMenuOpen: true }, ''); 
    }
  };

  const toggleAccountDropdown = () => {
    if (isAccountDropdownOpen) {
      closeMenus();
    } else {
      setIsAccountDropdownOpen(true);
      setIsMobileMenuOpen(false);
      window.history.pushState({ headerMenuOpen: true }, ''); 
    }
  };

  useEffect(() => {
    if (isMobileMenuOpen || isAccountDropdownOpen) {
      document.body.style.overflow = 'hidden'; 
    } else {
      document.body.style.overflow = 'unset'; 
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileMenuOpen, isAccountDropdownOpen]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (isAccountDropdownOpen && dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        closeMenus();
      }
      if (isMobileMenuOpen && mobileMenuRef.current && !mobileMenuRef.current.contains(event.target)) {
        if (!event.target.closest('.hamburger-btn')) {
          closeMenus();
        }
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isAccountDropdownOpen, isMobileMenuOpen]);

  const handleNavClick = (page) => {
    setView(page);
    closeMenus(); 
  };

  const handleAccountNav = (tab) => {
    if (setActiveTab) setActiveTab(tab);
    setView('account');
    closeMenus(); 
  };

  const handleLogout = () => {
    if(window.confirm("Are you sure you want to logout?")) {
      pb.authStore.clear();
      setView('home');
      closeMenus();
    }
  };

  return (
    <nav className="navbar">
      <div className="nav-header">
        <div className="nav-left">
          <button className="hamburger-btn" onClick={toggleMobileMenu}>
            {isMobileMenuOpen ? '✖' : '☰'}
          </button>
          <div className="logo" onClick={() => handleNavClick('home')}>
            Bah! <span>Car Plaza</span>
          </div>
        </div>

        <div className="search-container">
          {(view === 'home' || view === 'buy' || view === 'emi') && (
            <div className="search-bar">
              <span>🔍</span>
              <input type="text" placeholder="Search brands, models..." onChange={(e) => setSearchTerm(e.target.value)} />
              <div className="search-divider"></div>
              <select onChange={(e) => setCityFilter(e.target.value)}>
                <option value="">ALL CITIES</option>
                {CITIES.map(city => <option key={city} value={city}>{city}</option>)}
              </select>
            </div>
          )}
        </div>

        <div className="nav-right">
          <div className="desktop-menu">
            <div className="nav-links">
              <span onClick={() => handleNavClick('buy')} className={view === 'buy' ? 'active' : ''}>Buy Used Car</span>
              <span onClick={() => { if (pb.authStore.isValid) { handleNavClick('account'); if(setActiveTab) setActiveTab('Post Ad'); } else { handleNavClick('auth'); } }} 
                    className={(view === 'account' && activeTab === 'Post Ad') ? 'active' : ''}>Post Ad</span>
              <span onClick={() => handleNavClick('emi')} className={view === 'emi' ? 'active' : ''}>EMI Calculator</span>
              <span onClick={() => handleNavClick('blogs')} className={view === 'blogs' ? 'active' : ''}>Blog</span>
            </div>

            {pb.authStore.isValid && ['nabojyoti46@gmail.com', 'admin@test.com'].includes(pb.authStore.model?.email) && (
              <button onClick={() => handleNavClick('admin')} className="admin-badge">Admin</button>
            )}
          </div>

          <a href="tel:+916289913919" className="header-call-btn" title="Call Us">
             <img src={customCallIcon} alt="Call Us" style={{ width: '40px', height: '40px', objectFit: 'contain' }} />
          </a>

          {pb.authStore.isValid ? (
            <div className="account-dropdown-wrapper" ref={dropdownRef}>
              <div className="profile-avatar" onClick={toggleAccountDropdown} title="My Account">
                {pb.authStore.model?.avatar ? (
                  <img src={`https://bahcarplaza.com/api/files/${pb.authStore.model.collectionId}/${pb.authStore.model.id}/${pb.authStore.model.avatar}`} alt="Profile" />
                ) : (
                  pb.authStore.model?.name?.charAt(0).toUpperCase() || 'U'
                )}
              </div>

              {isAccountDropdownOpen && (
                <div className="account-dropdown">
                  <div className="dropdown-header">
                    <div className="dropdown-avatar-large">
                      {pb.authStore.model?.avatar ? (
                        <img src={`https://bahcarplaza.com/api/files/${pb.authStore.model.collectionId}/${pb.authStore.model.id}/${pb.authStore.model.avatar}`} alt="Profile" />
                      ) : (
                        pb.authStore.model?.name?.charAt(0).toUpperCase() || 'U'
                      )}
                    </div>
                    <h3 className="dropdown-name">{pb.authStore.model?.name || 'User'}</h3>
                    <p className="dropdown-email">{pb.authStore.model?.email}</p>
                  </div>
                  
                  <div className="dropdown-menu-list">
                    {MENU_ITEMS.map(item => (
                      <button 
                        key={item.name} 
                        className={`dropdown-menu-btn ${activeTab === item.name && view === 'account' ? 'active' : ''}`}
                        onClick={() => handleAccountNav(item.name)}
                      >
                        <span>{item.icon}</span> {item.name}
                      </button>
                    ))}
                    <button className="dropdown-logout-btn" onClick={handleLogout}>
                      <span>🚪</span> LOGOUT
                    </button>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <button onClick={() => handleNavClick('auth')} className="login-btn">Login/Sign Up</button>
          )}
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="mobile-main-menu" ref={mobileMenuRef}>
          <button className={`mobile-main-menu-btn ${view === 'buy' ? 'active' : ''}`} onClick={() => handleNavClick('buy')}>
            <span>🚘</span> Buy Used Car
          </button>
          
          <button className={`mobile-main-menu-btn ${(view === 'account' && activeTab === 'Post Ad') ? 'active' : ''}`} 
            onClick={() => { if (pb.authStore.isValid) { handleNavClick('account'); if(setActiveTab) setActiveTab('Post Ad'); } else { handleNavClick('auth'); } }}>
            <span>🏷️</span> Post Ad
          </button>
          
          <button className={`mobile-main-menu-btn ${view === 'emi' ? 'active' : ''}`} onClick={() => handleNavClick('emi')}>
            <span>🧮</span> EMI Calculator
          </button>
          
          <button className={`mobile-main-menu-btn ${view === 'blogs' ? 'active' : ''}`} onClick={() => handleNavClick('blogs')}>
            <span>📰</span> Blog
          </button>

          {pb.authStore.isValid && ['nabojyoti46@gmail.com', 'admin@test.com'].includes(pb.authStore.model?.email) && (
            <button className="mobile-main-menu-btn" onClick={() => handleNavClick('admin')} style={{ marginTop: '10px', backgroundColor: 'rgba(255,255,255,0.05)' }}>
              <span>⚙️</span> Admin Panel
            </button>
          )}
        </div>
      )}
    </nav>
  );
}

export default Header;